export default "__VITE_ASSET__BDfOBqxY__"